import React, { useEffect, useState, useCallback, useMemo, useRef } from "react";
import { LoadingOutlined, QuestionCircleOutlined, UploadOutlined, DownOutlined, AppstoreAddOutlined, PlusOutlined, DeleteOutlined, ArrowLeftOutlined, RetweetOutlined } from "@ant-design/icons";
import { useQuery } from "react-query";
import { Spin, Breadcrumb, Button, Popover, Dropdown, Space, Input, Menu, Layout, Row, Col, Form, message, Upload, Tooltip, Modal, Empty } from "antd";
import CustomerMainLayout from "../CustomerComponents/CustomerMainLayout";
import ActivityAndExploreSection from "./ActivityAndExploreSection";
import ProductSelectionModal from "./ProductSelectionModal"
import CreateProductModal from "./CreateProductModal"
import { THUMBNAIL_URL, WALMART_COMPANY_ID } from "../../../environments/env";
import ENVIRONMENT from "../../../environments";
import * as Utilities from '../../App/Utilities';
import pako from "pako";

import axios from "axios";
import AIGridOverlay from "./AIGridOverlay";
import "./index.scss";

import * as Constants from "../CustomerComponents/Constants";
import TwoDImagesModal from "../CustomerComponents/TwoDImagesPage/TwoDImagesModal";
import { dummyAIgeneratedImages } from "./DummyConstants";
import { setCookie, getCookie } from "../Utilities";
import posthog from "posthog-js";

import SubscriptionUpgradeManager from "../CustomerComponents/SubscriptionUpgradeManager/SubscriptionUpgradeManager";

const { Content } = Layout;
const {Dragger} = Upload
const TextArea = Input;


let CUSTOMER_USERNAME = localStorage.getItem("username");
let COMPANY_ID = localStorage.getItem('company_id')

const AssetCreateOptions = (props) => {
  const [modelLoader, setModelLoader] = useState(false)
  const [draggerOpened, setDraggerOpened] = useState(false)
  const [modelGenerationLoader, setModelGenerationLoader] = useState(false)
  const [filesList, setFilesList] = useState([])
  const [filesListRef, setFilesListRef] = useState([])
  const [selectedUnit, setSelectedUnit] = useState("inches");
  const [lifestylePrompt, setLifestylePrompt] = useState(props.previousImgPrompt);
  const [selectedImageForLifestyle, setSelectedImageForLifetsyle] = useState(props.selectedImgUri);
  const [selectedImageForInspectionLifestyle, setSelectedImageForInspectionLifestyle] = useState(props.selectedImgInspectionUri);
  const [isLifestyleRequestLoading, setIsLifestyleRequestLoading] = useState(false);
  const [width, setWidth] = useState(null);
  const [height, setHeight] = useState(null);
  const [depth, setDepth] = useState(null);
  const [units, setUnits] = useState(null);
  const draggerRef = useRef(null)
  const buttonRef = useRef(null);
  const inspDraggerRef1 = useRef(null);
  const inspDraggerRef2 = useRef(null);
  const inspButtonRef1 = useRef(null);
  const inspButtonRef2 = useRef(null);
  const [inspImageDraggerOpened, setInspImageDraggerOpened] = useState(false);
  const uploadButtonRef = useRef(null);
  const [form] = Form.useForm();
  const formRef = useRef(null);
  const [openProductModal, setOpenProductModal] = useState(false);
  const [openCreateProductModal, setOpenCreateProductModal] = useState(false);
  const [perspectiveRenders, setPerspectiveRenders] = useState([])
  const [regenerateJobLoader, setRegenerateJobLoader] = useState(null)
  const [exploreSectionActiveTab, setExploreSectionActiveTab] = useState('activity')
  const [promptValue, setPromptValue] = useState('')
  const [hoveredPreviewUid, setHoveredPreviewUid] = useState(null)
  const [isInspButtonFocused, setIsInspButtonFocused] = useState(false)
  const [isInspButtonHovered, setIsInspButtonHovered] = useState(false)
  const [propsList, setPropsList] = useState([]);
  const [existingProps, setExistingProps] = useState(props.initialProps || []);
  const [existingInspirationId, setExistingInspirationId] = useState(props.initialInspirationId || null);
  const [uploadType, setUploadType] = useState('product'); // 'product' or 'prop'
  const [inspirationLibraryModalOpen, setInspirationLibraryModalOpen] = useState(false);
  const [selectedInspirationFromLibrary, setSelectedInspirationFromLibrary] = useState(null);
  const [inspirationLibrarySearchValue, setInspirationLibrarySearchValue] = useState("");

  const hasInspirationLibrary = Array.isArray(props.inspirationLibrary) && props.inspirationLibrary.length > 0;

  const getInchesMultiplier = (unit) => {
    if (unit === "meters") return 39.3701;
    if (unit === "centimeters") return 0.393701;
    if (unit === "millimeters") return 0.0393701;
    if (unit === "feet") return 12;
    return 1; // inches (default)
  };

  const getLibraryImageUri = (obj) => {
    return obj?.image_uri || '';
  };

  const getLibraryThumbUri = (obj) => {
    return obj?.thumbnail || obj?.image_uri || '';
  };

  const getInspirationIdentifier = (item) => {
    return String(item?.identifier || '').trim();
  };

  const getDisplayImageSrc = (uri, platform = 'aws') => {
    if (!uri) return '';
    const u = String(uri);
    if (u.startsWith('http://') || u.startsWith('https://')) return u;
    const base = ENVIRONMENT.getBaseURL(platform);
    // Avoid double-encoding already-encoded URIs (they often contain %2F).
    const suffix = u.includes('%') ? u : encodeURIComponent(u);
    return base + suffix;
  };
  
  const clearGenerateMorePrefillFromUrl = () => {
    // After submitting from a "Generate more" deep link, clear prefill params so refresh starts clean.
    // Keep only stage=options (no product/job/img/prompt/props state in URL).
    try {
      const params = new URLSearchParams(window.location.search);
      params.delete("state");
      params.delete("img");
      params.delete("prompt");
      params.delete("imgInspection");
      params.delete("inspiration_id");
      params.delete("job_id");
      params.delete("productId");
      params.delete("aiModel");
      params.delete("expanded_job_id");
      params.delete("open_product_modal");
      params.set("stage", "options");
      const newUrl = `${window.location.pathname}?${params.toString()}`;
      window.history.replaceState({}, "", newUrl);
    } catch (e) {
      // no-op
    }
  };

  const launchAiCreatorTour = (first_time = false) => {
    let demoUrl = "";
    if (first_time) {
      demoUrl = new URL(`https://app.storylane.io/demo/${ENVIRONMENT.AI_CREATOR_STORYLANE_ID_WITH_REDIRECT}`);
    } else {
      demoUrl = new URL(`https://app.storylane.io/demo/${ENVIRONMENT.AI_CREATOR_STORYLANE_ID}`);  
    }
   
    if (window.Storylane) {
      window.Storylane.Play({
        type: 'popup',
        demo_type: 'image',
        width: 2560,
        height: 1442,
        scale: '0.95',
        demo_url: demoUrl,
        padding_bottom: 'calc(56.33% + 27px)'
      });
      setCookie('ai_creator_tour_viewed', 'true', 365);
      return true;
    }
    return false;
  };

  const loadStorylineScript = () => {
    const script = document.createElement('script');
    script.src = 'https://js.storylane.io/js/v1/storylane.js';
    script.async = true;
    
    script.onload = () => {
      const hasViewedTour = getCookie('ai_creator_tour_viewed');
      if (!hasViewedTour) {
        setTimeout(() => {
          launchAiCreatorTour(true);
        }, 1500);
      }
    };
    
    document.body.appendChild(script);
    return () => {
      if (document.body.contains(script)) {
        document.body.removeChild(script);
      }
    };
  };

  const handleAiCreatorTour = () => {
    const success = launchAiCreatorTour();
    if (!success) {
      message.warning('Tour is loading, please try again in a moment');
    }
  };

  const menu = (
    <Menu>
      <Menu.Item onClick={() => setSelectedUnit("inches")}>inches</Menu.Item>
      <Menu.Item onClick={() => setSelectedUnit("meters")}>meters</Menu.Item>
      <Menu.Item onClick={() => setSelectedUnit("centimeters")}>centimeters</Menu.Item>
                  <Menu.Item onClick={() => setSelectedUnit("millimeters")}>millimeters</Menu.Item>
                  <Menu.Item onClick={() => setSelectedUnit("feet")}>feet</Menu.Item>
    </Menu>
  );


  const validateFile = (file) => {
    const isAllowedFormat = [
      "image/png",
      "image/jpeg",
      "image/webp",
      "image/heic",
      "image/tiff"
    ].includes(file.type);

    if (!isAllowedFormat) {
      message.error("Only .png, .jpg, .webp, .heic, and .tiff formats are allowed.");
      return false;
    }

    return true;
  };

  const uploadPropsRef = {
    ...Constants.upload_props,
    multiple: false,
    accept: ".jpg,.jpeg,.png,.tiff,.webp,.heic",
    beforeUpload: (file) => {
      return validateFile(file)
    },
    fileList: filesListRef,
    onChange(info) {
      setFilesListRef([info.file]);

      const { status } = info.file;
      console.log(info);
      if (status === "uploading") {
        // If user is uploading a new inspiration, stop reusing the previous inspiration_id.
        setExistingInspirationId(null);
        setSelectedImageForInspectionLifestyle('loading');
        setInspImageDraggerOpened(false);
      } else if (status !== "uploading") {
        console.log(info.file, info.fileList);
      }
      if (status === "done") {
        setExistingInspirationId(null);
        setSelectedImageForInspectionLifestyle('test_files/' + info.file['uid'] + '/' + info.file['name']);
        message.success(`${info.file.name} file uploaded successfully.`);
      } else if (status === "error") {
        if(info.file.error.code.includes('Credentials')){
          message.error('Your session has expired. Please reload the page.')
        }
        else{
          message.error(`${info.file.name} file upload failed.`);
        }
      }
    },
    onDrop(e) {
      console.log("Dropped files", e.dataTransfer.files);
    },
  };

  useEffect(() => {
    if(props.openProductModal){
      handleProductAddOption();
    }
  }, [props.openProductModal])

  const handleClickOutside = (event) => {
    // Check if the click is outside the dragger
    if (draggerRef.current && !draggerRef.current.contains(event.target) && buttonRef.current && !buttonRef.current.contains(event.target)) {
      setDraggerOpened(false); // Update state when clicking outside
    }

    if (
      (inspDraggerRef1.current && !inspDraggerRef1.current.contains(event.target)) &&
      (inspButtonRef1.current && !inspButtonRef1.current.contains(event.target))
    ) {
      setInspImageDraggerOpened(false); // Update state when clicking outside
    }

    if (
      (inspDraggerRef2.current && !inspDraggerRef2.current.contains(event.target)) &&
      (inspButtonRef2.current && !inspButtonRef2.current.contains(event.target))
    ) {
      setInspImageDraggerOpened(false); // Update state when clicking outside
    }
  };

  const handleProductAddOption = () => {
    setUploadType('product');
    if (!props.requestStatusLoader && (props.requestStatus == "allowed" || props.requestStatus == "always_allowed")) {
      setOpenCreateProductModal(true);
    }
    else if(!props.requestStatusLoader){
      props.setCurrentRequestType('ai_model');
      props.setSubscriptionUpgradeManagerModel(true);
    }
  };

  const handlePropAddOption = () => {
      if ((propsList.length + existingProps.length) >= 3) {
          message.warning('Maximum 3 props allowed. Please delete an existing prop to add more.');
          return;
      }
      setUploadType('prop');
      setOpenCreateProductModal(true);
  }

  const handleCreateProductModalOk = (data) => {
    // Handle the uploaded files and dimensions from the modal
    if(uploadType === 'product'){
        setFilesList(data.files);
        setWidth(data.dimensions.width);
        setHeight(data.dimensions.height);
        setDepth(data.dimensions.depth);
        setSelectedUnit(data.dimensions.unit);
        setOpenCreateProductModal(false);
        props.setStage('upload_images');
    } else {
        // Prop flow: either upload a new prop OR select from library
        if (data?.source === 'library' && data?.libraryItem) {
          const lib = data.libraryItem;
          const imageUri = getLibraryImageUri(lib);
          if (!imageUri) {
            message.error('Selected library prop is missing image URI.');
            return;
          }
          const newExistingProp = {
            id: lib?.id,
            image_uri: imageUri,
            // Library props already have their own dimensions (if backend provides them).
            height: lib?.height ?? null,
            width: lib?.width ?? null,
            depth: lib?.depth ?? null,
          };
          // Prevent duplicates by id when available
          setExistingProps((prev) => {
            const prevArr = prev || [];
            if (newExistingProp?.id != null && prevArr.some(p => String(p?.id) === String(newExistingProp.id))) {
              return prevArr;
            }
            return [...prevArr, newExistingProp];
          });
          setOpenCreateProductModal(false);
          return;
        }

        const newProp = {
          uid: Date.now(),
          files: data.files,
          dimensions: data.dimensions
        };
        setPropsList([...propsList, newProp]);
        setOpenCreateProductModal(false);
    }
  };

  const handleCreateProductModalCancel = () => {
    setOpenCreateProductModal(false);
  };

  const handleFormSubmit = () => {

    posthog.capture("Generate clicked", {
        source: "AI Asset Creator",
        username: localStorage.getItem('username'),
    });

    let isFormValid = true
    let errorMessage = ""

    if(filesList.length == 0){
      isFormValid = false
      errorMessage = "Upload product images to proceed."
    }
    else{
      filesList.map((item) => {
        if(item.status === "uploading"){
          isFormValid = false
          errorMessage = "Please wait for the upload(s) to complete"
        }
        else if(item.status === "error"){
          isFormValid = false
          if(item.error.code.includes('Credentials')){
            errorMessage = 'Your session has expired. Please reload the page.'
          }
          else{
            errorMessage = `${item.name} file upload failed.`
          }
        }
      })
    }
      
    if(height < 0 || width < 0 || depth < 0){
      isFormValid = false;
      errorMessage = "Product dimensions needs to be positive"
    }
    if(!isFormValid && errorMessage){
      message.error(errorMessage)
    }
    
    let values = {
      height: height,
      width: width,
      depth: depth
    }
    generateAiAssets(values)
  }

  const regnerateLifestyleJob = (jobData) => {
    
    setRegenerateJobLoader(jobData["job_id"])
    let payload = {
      "job_id": jobData["job_id"],
      "action": "regnerate_job"
    }    

    axios.post(ENVIRONMENT.AI_MODEL_HELPER, payload).then((res) => {
      props.fetchYourActivityRendersData(() => {{
        setRegenerateJobLoader(false)
      }}, false, true); // Poll silently without showing loader

    }); 

  }
 
  const handleLifeStyleRequest = () => {
    if (props.imageRequestStatus == "allowed" || props.imageRequestStatus == "always_allowed") {
      performLifeStyleRequest()
    }
    else {
      props.setCurrentRequestType('ai_image_1k');
      props.setSubscriptionUpgradeManagerModel(true);
    }
  }

  const performLifeStyleRequest = () => {
    let props_payload = propsList.map((prop) => {
      const unitMultiplier = getInchesMultiplier(prop?.dimensions?.unit);
      const firstFile = prop?.files?.[0];
      const image_url = firstFile
        ? ENVIRONMENT.getBaseURL(props.selectedProductPlatform) +
          encodeURIComponent("test_files/" + firstFile.uid + "/" + firstFile.name)
        : null;

      return {
        image_url: image_url,
        height: parseFloat(prop.dimensions.height) * unitMultiplier,
        width: parseFloat(prop.dimensions.width) * unitMultiplier,
        depth: parseFloat(prop.dimensions.depth) * unitMultiplier,
      };
    }).filter(p => p.image_url);

    // Include existing props (pre-populated from Generate more redirect state)
    const existingPropsPayload = (existingProps || [])
      .map((p) => {
        const toNumOrNull = (v) => {
          const n = parseFloat(v);
          return Number.isFinite(n) ? n : null;
        };
        const uri = p?.image_uri;
        if (!uri) return null;
        const image_url = uri.includes('https://')
          ? uri
          : ENVIRONMENT.getBaseURL(props.selectedProductPlatform) + uri;
        return {
          id: p?.id,
          image_url,
          height: toNumOrNull(p?.height),
          width: toNumOrNull(p?.width),
          depth: toNumOrNull(p?.depth),
        };
      })
      .filter(Boolean);

    props_payload = [...existingPropsPayload, ...props_payload];

    let request_payload = {
        "action": "trigger_lifestyle_generation_job",
        "product_id": props.productId,
        "job_id": props.jobId || null,
        "inspiration_id": existingInspirationId,
        "username": CUSTOMER_USERNAME,
        "prompt": lifestylePrompt.trim(),
        width: width,
        height: height,
        depth: depth,
        units: 'inches',
        "image_urls": [encodeURIComponent(selectedImageForLifestyle)],
        "company_id": COMPANY_ID || null,
        "platform": props.selectedProductPlatform,
        "asset_type": "ai_image_1k",
        "props": props_payload
    }

    if (filesListRef.length > 0) {
      request_payload.ref_url = ENVIRONMENT.getBaseURL(props.selectedProductPlatform) + "test_files/" + filesListRef[0].uid + "/" + encodeURIComponent(filesListRef[0].name)
    }
    else if(selectedImageForInspectionLifestyle){
      request_payload.ref_url = String(selectedImageForInspectionLifestyle).startsWith('http')
        ? selectedImageForInspectionLifestyle
        : (ENVIRONMENT.getBaseURL(props.selectedProductPlatform) + selectedImageForInspectionLifestyle)
    }

    console.log(JSON.stringify(request_payload))

    let gateway_payload = {
      "username": localStorage.getItem('username'),
      "request_type": "ai_image_1k",
      "action": "perform",
      "request_payload": request_payload,
      "category": "",
      "entities_per_request": 4,
      "request_id": Date.now().toString()
  }  

  console.log(JSON.stringify(gateway_payload))

    setIsLifestyleRequestLoading(true);
    axios.post(ENVIRONMENT.PAYMENT_GATEWAY, gateway_payload).then((res) => {
      props.fetchYourActivityRendersData(() => {{
          setLifestylePrompt('');
          setSelectedImageForLifetsyle('');
          setIsLifestyleRequestLoading(false);
          setExploreSectionActiveTab('activity')
          message.success('Request Submitted Successfully')
          props.setStage('options')
          clearGenerateMorePrefillFromUrl();
      }}, false, true); // Poll silently without showing loader

    });  

    // track ai flow analytics
    let aiFlowAnalyticsPayload = {
      'username': CUSTOMER_USERNAME,
      'product_id': props.productId,
      'prompt': lifestylePrompt,
      'ai_flow_state': 'Lifestyle Generation',
      'action': 'Lifestyle Generation',
      'referrer': document.referrer,
      'timestamp': new Date().toISOString(),
      'device_info': navigator.userAgent,
    }
    axios.post(ENVIRONMENT.AI_FLOW_ANALYTICS, aiFlowAnalyticsPayload)
  } 

  const handleOpenInspirationLibrary = () => {
    if (!hasInspirationLibrary) return;
    setSelectedInspirationFromLibrary(null);
    setInspirationLibraryModalOpen(true);
    setInspImageDraggerOpened(false);
  };

  const handleConfirmInspirationFromLibrary = () => {
    if (!selectedInspirationFromLibrary) {
      message.error('Please select an inspiration from the library.');
      return;
    }
    const inspirationUri = getLibraryImageUri(selectedInspirationFromLibrary);
    if (!inspirationUri) {
      message.error('Selected inspiration is missing image URI.');
      return;
    }
    setExistingInspirationId(selectedInspirationFromLibrary?.id || null);
    setSelectedImageForInspectionLifestyle(inspirationUri);
    setFilesListRef([]); // clear any uploaded inspiration
    setInspirationLibraryModalOpen(false);
  };

  const handleCancelInspirationLibraryModal = () => {
    setSelectedInspirationFromLibrary(null);
    setInspirationLibrarySearchValue("");
    setInspirationLibraryModalOpen(false);
  };

  const generateFilesUrls = () => {
    let urls = []
    for(const obj of filesList){
      urls.push(ENVIRONMENT.getBaseURL(props.selectedProductPlatform) + encodeURIComponent('test_files/' + obj.uid + '/' + obj.name))
    }
    return urls
  }

  const generateAiAssets = (values) => {
    if (props.requestStatus == "allowed" || props.requestStatus == "always_allowed") {
      performGenerateAiAssets(values)
    }
    else {
      props.setCurrentRequestType('ai_model');
      props.setSubscriptionUpgradeManagerModel(true);
    }
  }
  
  const performGenerateAiAssets = (values) => {
    let dimensionMultiplier = 1;
    if (selectedUnit == "meters") {
      dimensionMultiplier = 39.3701;
    } else if (selectedUnit == "centimeters") {
      dimensionMultiplier = 0.393701;
    } else if (selectedUnit === "millimeters") {
      dimensionMultiplier = 0.0393701; // 1 mm = 0.0393701 inches
    } else if (selectedUnit === "feet") {
      dimensionMultiplier = 12; // 1 foot = 12 inches
    }

    let payload = {
      product_name: 'Untitled',
      brand_id: "",
      product_model_type: "product",
      dimensions: "inches",
      height: parseFloat(values.height) * dimensionMultiplier,
      width: parseFloat(values.width) * dimensionMultiplier,
      length: parseFloat(values.depth) * dimensionMultiplier,
      materials: [],
      model_status: 13,
      group_id: "",
      components: [],
      user_type: "customer",
      pantone_color: "",
      hex_color: "",
      is_configurable: false,
      need_to_model: "low_res",
      modeling_required: true,
      uploaded_model: false,
      designed_product: true,
      licensing_options: {"license": "private"},
      segmented: false,
      user_usecase: ["low_res"],
      company_id: COMPANY_ID,
      username: CUSTOMER_USERNAME,
      is_ai_model: true,
      product_photos: filesList,
      model_info: {
        height: parseFloat(values.height) * dimensionMultiplier,
        width: parseFloat(values.width) * dimensionMultiplier,
        depth: parseFloat(values.depth) * dimensionMultiplier,
      }
    }
    setModelGenerationLoader(true)
    
    // track ai flow analytics
    let aiFlowAnalyticsPayload = {
      'username': CUSTOMER_USERNAME,
      'ai_flow_state': 'AI Model Creation',
      'action': 'AI Model Creation',
      'referrer': document.referrer,
      'timestamp': new Date().toISOString(),
      'device_info': navigator.userAgent,
    }
    axios.post(ENVIRONMENT.AI_FLOW_ANALYTICS, aiFlowAnalyticsPayload)


    let metadata_extract_payload = {
      "urls": generateFilesUrls(),
      // "pid": productId  //this is to be added on the back-end
    }

    let helperPayload = {
      "action": "trigger_model_generation_job", 
      "image_urls": generateFilesUrls(), 
      // "product_id": productId,   //this is to be added on the back-end
      "height": parseFloat(values.height) * dimensionMultiplier,
      "width": parseFloat(values.width) * dimensionMultiplier,
      "depth": parseFloat(values.depth) * dimensionMultiplier,
      "units": "inches", 
      "username": CUSTOMER_USERNAME,
      "company_id": COMPANY_ID || null
    }

    let props_payload = propsList.map((prop) => {
      const unitMultiplier = getInchesMultiplier(prop?.dimensions?.unit);
      const firstFile = prop?.files?.[0];
      const image_url = firstFile
        ? ENVIRONMENT.getBaseURL(props.selectedProductPlatform) +
          encodeURIComponent("test_files/" + firstFile.uid + "/" + firstFile.name)
        : null;

      return {
        image_url: image_url,
        height: parseFloat(prop.dimensions.height) * unitMultiplier,
        width: parseFloat(prop.dimensions.width) * unitMultiplier,
        depth: parseFloat(prop.dimensions.depth) * unitMultiplier,
      };
    }).filter(p => p.image_url);

    let lifestyleGenerationPayload = {
      "action": "trigger_lifestyle_generation_job",
      // "product_id": productId,  //this is to be added on the back-end
      "username": CUSTOMER_USERNAME,
      "height": parseFloat(values.height) * dimensionMultiplier,
      "width": parseFloat(values.width) * dimensionMultiplier,
      "depth": parseFloat(values.depth) * dimensionMultiplier,
      "units": "inches", 
      "prompt": promptValue,
      "image_urls": generateFilesUrls(), 
      "company_id": COMPANY_ID || null,
      "props": props_payload
    }
    if (filesListRef.length > 0) {
      lifestyleGenerationPayload.ref_url = ENVIRONMENT.getBaseURL(props.selectedProductPlatform) + "test_files/" + filesListRef[0].uid + "/" + encodeURIComponent(filesListRef[0].name)
    }
    console.log(lifestyleGenerationPayload)

    let aiGenerateAssetsPayload = {
      'model_create_payload': payload,
      'metadata_extract_payload': metadata_extract_payload,
      'model_generation_job_payload': helperPayload,
      'lifestyle_generation_job_payload': lifestyleGenerationPayload
    }

    console.log(JSON.stringify(aiGenerateAssetsPayload))

    let gateway_payload = {
      "username": localStorage.getItem('username'),
      "request_type": "ai_model",
      "action": "perform",
      "request_payload": aiGenerateAssetsPayload,
      "category": "",
      "request_id": Date.now().toString()
  }  

  if(promptValue.trim() != ""){
    posthog.capture("Generate with Prompt", {
      prompt: promptValue,
      username: localStorage.getItem('username'),
    })
  }

  if(lifestyleGenerationPayload.ref_url){
    posthog.capture("Generate with Inspiration Image", {
      ref_url: lifestyleGenerationPayload.ref_url,
      username: localStorage.getItem('username'),
    })
  }

    console.log(JSON.stringify(gateway_payload))
    axios.post(ENVIRONMENT.PAYMENT_GATEWAY, gateway_payload)
        .then(res => {
            if (res.data.status!=undefined && res.data.status == 1) {
              message.success("Request Submitted")
              setModelGenerationLoader(false)
              window.location.reload();
            }
            else{
                message.error('Something went wrong');
            }
        })
        .catch(error => {
          message.error('Something went wrong with your request');
          setModelGenerationLoader(false)
        });
    return
  }

  useEffect(() => {
    // Add event listener to detect clicks outside
    document.addEventListener("click", handleClickOutside);
    // document.addEventListener("click", handleProductAddOption);

    const cleanupScript = loadStorylineScript();
    return () => {
      // Cleanup event listener
      document.removeEventListener("click", handleClickOutside);
      cleanupScript();
    };
  }, []);

  useEffect(() => {
    if(props.productId && props.stage == 'lifestyle_generation'){
      setModelLoader(true)

      if(props.aiModel){
        // Get Model details
        axios.post(ENVIRONMENT.FETCH_PRODUCT, {product_id: props.productId}).then((res) => {
          let photos = []
          if(res && res.data && res.data.product_photos){
            if(res.data.product_photos){
              photos = res.data.product_photos
            }
            else if(res.data.product_photos){
              photos = res.data.product_photos
            }
            let uris = []
            photos.map((obj) => {
              let uri = 'test_files/' + obj.uid + '/' + obj.name
              uris.push(uri)
            })

            setPerspectiveRenders(uris)
            if (uris.length  == 1) {
              //If there is just one image, it should be selected by default
              setSelectedImageForLifetsyle(uris[0])
            }

            setModelLoader(false)
            console.log('res.data - ', res.data)
            setHeight(!res.data.height ? 12 : res.data.height)
            setWidth(!res.data.width ? 12 : res.data.width)
            setDepth(!res.data.length ? 12 : res.data.length)
            props.setSelectedProductPlatform(res.data.platform)
          }
        })
      }
      else{
        axios.post(ENVIRONMENT.RENDER_PRODUCT, {product_id: props.productId}).then((res) => {
          if(res && res.data){
            setHeight(res.data.height == "" ? 12 : res.data.height )
            setWidth(res.data.width  == "" ? 12 : res.data.width)
            setDepth(res.data.depth == "" ? 12 : res.data.depth)
            props.setSelectedProductPlatform(res.data.platform)

            let uris = []
            let baseUrl = ENVIRONMENT.getBaseURL(res.data.platform)
            if(res.data && res.data['2d']){
              res.data['2d'].filter(item => !item.includes('Dimensions')).map(link => {
                let uri = link.split(baseUrl)[1]
                uris.push(uri)
              })
              setPerspectiveRenders(uris)
              if (uris.length  == 1) {
                //If there is just one image, it should be selected by default
                setSelectedImageForLifetsyle(uris[0])
              }
              setModelLoader(false)
            }
          }
        })
      }
    }
  }, [props.productId, props.stage])

  useEffect(() => {
    // track ai flow analytics
    let payload = {
      'username': CUSTOMER_USERNAME,
      'ai_flow_state': props.stage == 'options' ? 'AI Creator Page' : props.stage == 'upload_images' ? 'AI Model Creation' : 'Lifestyle Generation',
      'action': 'Navigation',
      'referrer': document.referrer,
      'timestamp': new Date().toISOString(),
      'device_info': navigator.userAgent
    }
    axios.post(ENVIRONMENT.AI_FLOW_ANALYTICS, payload)

  }, [props.stage])

  useEffect(() => {
    if (props.selectedImgInspectionUri) {
      setSelectedImageForInspectionLifestyle(props.selectedImgInspectionUri);
    }
    if (props.previousImgPrompt) {
      setLifestylePrompt(props.previousImgPrompt);
    }
  }, [props.selectedImgInspectionUri, props.previousImgPrompt])

  return (
    <Content className="ai-background-container">
      <Row style={{padding: '0px 30px', width: '95%'}}>
        <ProductSelectionModal selectedProductId={props.productId} 
        setSelectedProductId={props.setProductId} setSelectedProductPlatform={props.setSelectedProductPlatform}
        visible={openProductModal} setStage={props.setStage}
        setOpenProductModal={setOpenProductModal} setAiModel={props.setAiModel}/>
        
        <CreateProductModal 
          visible={openCreateProductModal}
          onOk={handleCreateProductModalOk}
          onCancel={handleCreateProductModalCancel}
          mode={uploadType}
          propsLibrary={props.propsLibrary || []}
        />
        {(props.stage == "lifestyle_generation") &&
          <Col span={24} className="mt-16" style={{borderRadius: 8, backgroundColor: 'white'}}>
            <Breadcrumb className='justify-in-start' style={{padding: 16}}>
              <ArrowLeftOutlined onClick={() => window.location.href = '/ai-asset-creator?stage=options'} className="mr-5"/>
              <Breadcrumb.Item>
                  <a className='manrope f-14' href='/ai-asset-creator?stage=options'>Create new image</a>
              </Breadcrumb.Item>
              {props.stage == "lifestyle_generation" &&
                <Breadcrumb.Item>
                    <div className='manrope f-14 black-33'>Generate more images</div>
                </Breadcrumb.Item>
              }
            </Breadcrumb>
          </Col>
        }
        {props.stage == 'options' ?
        <Col span={14} offset={5} >
          <Col span={24} className="justify-in-center">
            <h2 className="manrope f-24 w-700 black-00 mt-40">Create a new image</h2>
          </Col>
          <Col span={24}>
            <div style={{ marginTop: 24, display: 'flex', alignItems: 'center', gap: '16px' }}>
              <div id='generate-options' style={{ flex: 1 }}>
                <div ref={buttonRef} className="blue-on-hover" style={{ padding: '9px 20px', borderRadius: '2px', backgroundColor: '#F5F5F5' }} onClick={handleProductAddOption}>
                  <svg className="ai-upload-image" xmlns="http://www.w3.org/2000/svg" width="17" height="12" viewBox="0 0 17 16" fill="black">
                    <path d="M8.78558 1.57227H7.71415C7.61891 1.57227 7.57129 1.61988 7.57129 1.71512V7.32227H2.25028C2.15504 7.32227 2.10742 7.36988 2.10742 7.46512V8.53655C2.10742 8.63179 2.15504 8.67941 2.25028 8.67941H7.57129V14.2866C7.57129 14.3818 7.61891 14.4294 7.71415 14.4294H8.78558C8.88081 14.4294 8.92843 14.3818 8.92843 14.2866V8.67941H14.2503C14.3455 8.67941 14.3931 8.63179 14.3931 8.53655V7.46512C14.3931 7.36988 14.3455 7.32227 14.2503 7.32227H8.92843V1.71512C8.92843 1.61988 8.88081 1.57227 8.78558 1.57227Z"
                      fill="currentColor"
                      fillOpacity="0.85"
                    />
                  </svg>
                  <span className="manrope f-14 w-500" style={{ paddingLeft: 4, marginRight: 4 }}>Add a product</span>
                  {props.requestStatusLoader && <LoadingOutlined />}
                </div>
                <Button 
                  className="generate-ai-btn font-14"
                  onClick={() => handleFormSubmit()}
                  disabled={modelGenerationLoader || ((filesListRef.length < 1) && !promptValue.trim())}
                >
                  <img src="/img/ai_creator/ai-twinkle.svg" style={{ width: '20px', height: '20px', marginRight: '8px' }} /> 
                  <span>Generate</span>
                  {modelGenerationLoader && <LoadingOutlined />}
                </Button>
              </div>
                <Tooltip title={<span className="manrope f-12 white">Help</span>}>
                    <QuestionCircleOutlined onClick={handleAiCreatorTour} style={{ fontSize: '18px', color: 'black', cursor: 'pointer' }}/>
                </Tooltip>
              </div>
          </Col>
        </Col>
        : props.stage == 'upload_images' ?
          <Col span={14} offset={5} style={{color: 'black'}}>
            <Col span={24} className="justify-in-center">
              <h2 className="manrope f-24 w-700 black-00 mt-40">Add a prompt or inspiration photo</h2>
            </Col>
            <Col span={24}>
              <div style={{ marginTop: 24 }}>
                <div id='generate-box'>
                <div style={{ display: 'flex', gap: '12px', flexWrap: 'wrap', marginBottom: '16px' }}>
                  {[...filesList, ...filesListRef].map((file) => (
                    <div
                      key={file.uid}
                      style={{
                        position: 'relative',
                        width: '132px',
                        height: '132px',
                        border: '1px solid #D9D9D9',
                        borderRadius: '8px',
                        overflow: 'hidden',
                        backgroundColor: 'white'
                      }}
                      onMouseEnter={() => setHoveredPreviewUid(file.uid)}
                      onMouseLeave={() => setHoveredPreviewUid(null)}
                    >
                      {file.status === "uploading" ? (
                        <div style={{ 
                          display: 'flex', 
                          alignItems: 'center', 
                          justifyContent: 'center', 
                          height: '100%',
                          backgroundColor: '#f5f5f5'
                        }}>
                          <Spin indicator={<LoadingOutlined spin />} style={{color: '#8C8C8C'}} size="large" />
                        </div>
                      ) : (
                        <>
                          <div style={{ width: '100%', height: '100%', overflow: 'hidden' }}>
                            <img
                              style={{
                                width: '100%',
                                height: '100%',
                                objectFit: 'cover'
                              }}
                              src={ENVIRONMENT.getBaseURL('aws') + encodeURIComponent("test_files" + "/" + file.uid + "/" + file.name)}
                              alt={file.name}
                            />
                          </div>
                          <Button
                            onClick={() => {
                              if (filesList.find(x => x.uid === file.uid)) {
                                setFilesList(prev => prev.filter(item => item.uid !== file.uid));
                                setFilesListRef([]);
                                props.setStage('options')
                              }
                              if (filesListRef.find && filesListRef.find(x => x.uid === file.uid)) {
                                setFilesListRef([]);
                              }
                            }}
                            style={{
                              position: 'absolute',
                              top: '8px',
                              left: '8px',
                              width: '24px',
                              height: '24px',
                              minWidth: '24px',
                              padding: '0',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              backgroundColor: '#000000',
                              borderRadius: '4px',
                              border: 'none',
                              opacity: hoveredPreviewUid === file.uid ? 1 : 0,
                              transition: 'opacity 120ms ease-in-out'
                            }}
                          >
                            <DeleteOutlined style={{ color: 'white', fontSize: '12px' }} />
                          </Button>
                        </>
                      )}
                    </div>
                  ))}
                  {propsList.length > 0 && propsList.map((prop) => (
                    <div
                      key={prop.uid}
                      style={{
                        position: 'relative',
                        width: '132px',
                        height: '132px',
                        border: '1px solid #D9D9D9',
                        borderRadius: '8px',
                        overflow: 'hidden',
                        backgroundColor: 'white'
                      }}
                    >
                      <img
                        style={{
                          width: '100%',
                          height: '100%',
                          objectFit: 'cover'
                        }}
                        src={ENVIRONMENT.getBaseURL('aws') + encodeURIComponent("test_files" + "/" + prop.files[0].uid + "/" + prop.files[0].name)}
                        alt="Prop"
                      />
                      <Button
                        onClick={() => {
                          setPropsList(prev => prev.filter(p => p.uid !== prop.uid));
                        }}
                        style={{
                          position: 'absolute',
                          top: '4px',
                          right: '4px',
                          width: '20px',
                          height: '20px',
                          minWidth: '20px',
                          padding: '0',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          backgroundColor: 'rgba(0,0,0,0.5)',
                          borderRadius: '4px',
                          border: 'none',
                        }}
                      >
                        <DeleteOutlined style={{ color: 'white', fontSize: '10px' }} />
                      </Button>
                    </div>
                  ))}
                  {existingProps.length > 0 && existingProps.map((prop, idx) => (
                    <div
                      key={`existing-prop-obj-${prop?.id || idx}`}
                      style={{
                        position: 'relative',
                        width: '132px',
                        height: '132px',
                        border: '1px solid #D9D9D9',
                        borderRadius: '8px',
                        overflow: 'hidden',
                        backgroundColor: 'white'
                      }}
                    >
                      <img
                        style={{
                          width: '100%',
                          height: '100%',
                          objectFit: 'cover'
                        }}
                        src={
                          prop?.image_uri?.includes('https://')
                            ? prop.image_uri
                            : ENVIRONMENT.getBaseURL(props.selectedProductPlatform) + (prop?.image_uri || '')
                        }
                        alt="Prop"
                      />
                      <Button
                        onClick={() => {
                          setExistingProps(prev => prev.filter((_, i) => i !== idx));
                        }}
                        style={{
                          position: 'absolute',
                          top: '4px',
                          right: '4px',
                          width: '20px',
                          height: '20px',
                          minWidth: '20px',
                          padding: '0',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          backgroundColor: 'rgba(0,0,0,0.5)',
                          borderRadius: '4px',
                          border: 'none',
                        }}
                      >
                        <DeleteOutlined style={{ color: 'white', fontSize: '10px' }} />
                      </Button>
                    </div>
                  ))}
                </div>
                <div style={{marginBottom: '16px'}}>
                  <Input.TextArea
                    placeholder="Enter a short prompt..." 
                    className="dimnesion-item-input input-prompt-style"
                    value={promptValue}
                    onChange={(e) => setPromptValue(e.target.value)}
                    autoSize={{ minRows: 3, maxRows: 20 }}
                    style={{ resize: 'none', border: 'none' }}
                  />
                </div>
                <div className="justify-in-between">
                  <div className="justify-in-start">
                    <Button 
                        onClick={handlePropAddOption}
                        className="insp-img-upload-btn"
                    >
                      <PlusOutlined style={{ marginRight: '8px' }} /> 
                      <span className="manrope f-14 w-500">Add Prop</span>
                    </Button>
                    <Button ref={inspButtonRef1}
                        onClick={() => setInspImageDraggerOpened(true)}
                        className="insp-img-upload-btn ml-8"
                        onFocus={() => setIsInspButtonFocused(true)}
                        onBlur={() => setIsInspButtonFocused(false)}
                        onMouseEnter={() => setIsInspButtonHovered(true)}
                        onMouseLeave={() => setIsInspButtonHovered(false)}
                    >
                      <img src={(isInspButtonFocused || isInspButtonHovered) ? '/img/ai_creator/heart-blue.svg' : '/img/ai_creator/HeartAddOutlines.svg'} style={{ marginRight: '8px' }} /> 
                      <span className="manrope f-14 w-500">{filesListRef.length == 0 ? "Add inspiration" : "Replace inspiration"}</span>
                    </Button>
                    <span className="manrope f-12 w-600" style={{color: '#9254DE', marginLeft: '8px'}}>For a quicker match!</span>
                  </div>

                  <Tooltip 
                      title={((filesListRef.length < 1) && !promptValue.trim()) ? "Please upload an inspiration image or Enter a prompt to continue" : ""}
                    >
                    <span style={{ display: 'inline-block' }}>
                      <Button 
                        className="generate-ai-btn font-14"
                        onClick={() => handleFormSubmit()}
                        disabled={modelGenerationLoader || ((filesListRef.length < 1) && !promptValue.trim())}
                      >
                        <img src="/img/ai_creator/ai-twinkle.svg" style={{ width: '20px', height: '20px', marginRight: '8px' }} /> 
                        <span>Generate</span>
                        {modelGenerationLoader && <LoadingOutlined />}
                      </Button>
                    </span>
                  </Tooltip>
                </div>

              </div>
              </div>
            </Col>
            {inspImageDraggerOpened &&
                
                  <div ref={inspDraggerRef1} className="dragger-container">
                    <Dragger
                        accept=".jpg,.jpeg,.png,.tiff"
                        className="upload-height-170"
                        {...uploadPropsRef}
                        style={{
                          border: "1px dashed #595959",
                          background: "white",
                          borderRadius: 8,
                          padding: 16,
                          textAlign: "center",
                          position: "absolute",
                          top: 6,
                          left: 0,
                          right: 0
                        }}
                      >
                        <div className="manrope">  
                          <div style={{color: "black"}} >Drag & Drop or</div>
                          <div className="mt-10" style={{ display: 'flex', gap: 12, justifyContent: 'center', alignItems: 'center', flexWrap: 'wrap' }}>
                            <span style={{border: "1px solid #D9D9D9", display: 'inline-block', borderRadius: 4, padding: "8px 10px", color: "black"}}>
                              <UploadOutlined style={{marginRight: 4}} /> Upload photo
                            </span>
                            {hasInspirationLibrary && (
                              <Button
                                type="link"
                                className="manrope f-12 w-600"
                                style={{ padding: 0, height: 'auto' }}
                                onClick={(e) => {
                                  e.preventDefault();
                                  e.stopPropagation();
                                  handleOpenInspirationLibrary();
                                }}
                              >
                                or Select from Library
                              </Button>
                            )}
                          </div>
                          <div className="mt-10" style={{ fontSize: 12, color: "#595959" }}>
                          Supported formats: JPG, PNG, WebP, HEIC, or TIFF
                          </div>
                        </div>
                      </Dragger>
                  </div>
               
                }
          </Col>
        : props.stage == 'lifestyle_generation' && props.productId ?
          <Col span={16} offset={4}>
            <Col span={24} className="justify-in-center">
              <h2 className="manrope f-24 w-700 black-00 mt-40">Generate more images</h2>
            </Col>
            <Col span={24}>
              <div style={{ marginTop: 24 }}>
                <div id='generate-box'>
                  <div style={{ display: 'flex', gap: '12px', flexWrap: 'wrap', marginBottom: '16px' }}>
                  {modelLoader ? 
                    <div className="ai-uploaded-file-card">
                      <div className="loader">
                        <Spin indicator={<LoadingOutlined spin />} style={{color: '#8C8C8C'}} size="large" />
                      </div>
                    </div>
                    :
                      <>
                        {perspectiveRenders.map((uri) => (
                          uri === "loading" ? (
                            <div
                                style={{
                                  position: 'relative',
                                  width: '132px',
                                  height: '132px',
                                  border: '1px solid #D9D9D9',
                                  borderRadius: '8px',
                                  overflow: 'hidden',
                                  backgroundColor: 'white'
                            }}>
                              <div style={{ 
                                display: 'flex', 
                                alignItems: 'center', 
                                justifyContent: 'center', 
                                height: '100%',
                                backgroundColor: '#f5f5f5'
                              }}>
                                <Spin indicator={<LoadingOutlined spin />} style={{color: '#8C8C8C'}} size="large" />
                              </div>
                            </div>
                          ):
                          <div className={`ai-uploaded-file-card`}>
                              <img
                                className="ai-file-card-image"
                                src={
                                  ENVIRONMENT.getBaseURL(props.selectedProductPlatform) + encodeURIComponent(uri)
                                }
                              />
                          </div>
                        ))}
                        {selectedImageForInspectionLifestyle && (
                          selectedImageForInspectionLifestyle === 'loading' ? (
                            <div
                              style={{
                                position: 'relative',
                                width: '132px',
                                height: '132px',
                                border: '1px solid #D9D9D9',
                                borderRadius: '8px',
                                overflow: 'hidden',
                                backgroundColor: 'white'
                              }}
                            >
                              <div style={{ 
                                display: 'flex', 
                                alignItems: 'center', 
                                justifyContent: 'center', 
                                height: '100%',
                                backgroundColor: '#f5f5f5'
                              }}>
                                <Spin indicator={<LoadingOutlined spin />} style={{color: '#8C8C8C'}} size="large" />
                              </div>
                            </div>
                          ) : (
                            <div className={`ai-uploaded-file-card`} style={{ position: 'relative' }}>
                              <img
                                className="ai-file-card-image"
                                src={
                                  getDisplayImageSrc(selectedImageForInspectionLifestyle, props.selectedProductPlatform)
                                }
                              />
                              <Button
                                onClick={() => {
                                  setSelectedImageForInspectionLifestyle(null);
                                  setFilesListRef([]);
                                  setExistingInspirationId(null);
                                }}
                                style={{
                                  position: 'absolute',
                                  top: '8px',
                                  left: '8px',
                                  width: '24px',
                                  height: '24px',
                                  minWidth: '24px',
                                  padding: 0,
                                  display: 'flex',
                                  alignItems: 'center',
                                  justifyContent: 'center',
                                  borderRadius: '4px',
                                  border: 'none',
                                  backgroundColor: 'rgba(0, 0, 0, 0.6)',
                                  cursor: 'pointer',
                                  zIndex: 1
                                }}
                                onMouseEnter={(e) => {
                                  e.currentTarget.style.backgroundColor = 'rgba(0, 0, 0, 0.8)';
                                }}
                                onMouseLeave={(e) => {
                                  e.currentTarget.style.backgroundColor = 'rgba(0, 0, 0, 0.6)';
                                }}
                              >
                                <DeleteOutlined style={{ color: 'white', fontSize: '14px' }} />
                              </Button>
                            </div>
                          )
                        )}
                        {propsList.length > 0 && propsList.map((prop) => (
                          <div
                            key={prop.uid}
                            style={{
                              position: 'relative',
                              width: '132px',
                              height: '132px',
                              border: '1px solid #D9D9D9',
                              borderRadius: '8px',
                              overflow: 'hidden',
                              backgroundColor: 'white'
                            }}
                          >
                            <img
                              style={{
                                width: '100%',
                                height: '100%',
                                objectFit: 'cover'
                              }}
                              src={ENVIRONMENT.getBaseURL('aws') + encodeURIComponent("test_files" + "/" + prop.files[0].uid + "/" + prop.files[0].name)}
                              alt="Prop"
                            />
                            <Button
                              onClick={() => {
                                setPropsList(prev => prev.filter(p => p.uid !== prop.uid));
                              }}
                              style={{
                                position: 'absolute',
                                top: '4px',
                                right: '4px',
                                width: '20px',
                                height: '20px',
                                minWidth: '20px',
                                padding: '0',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                backgroundColor: 'rgba(0,0,0,0.5)',
                                borderRadius: '4px',
                                border: 'none',
                              }}
                            >
                              <DeleteOutlined style={{ color: 'white', fontSize: '10px' }} />
                            </Button>
                          </div>
                        ))}
                        {existingProps.length > 0 && existingProps.map((prop, idx) => (
                          <div
                            key={`existing-prop-obj-${prop?.id || idx}`}
                            style={{
                              position: 'relative',
                              width: '132px',
                              height: '132px',
                              border: '1px solid #D9D9D9',
                              borderRadius: '8px',
                              overflow: 'hidden',
                              backgroundColor: 'white'
                            }}
                          >
                            <img
                              style={{
                                width: '100%',
                                height: '100%',
                                objectFit: 'cover'
                              }}
                              src={
                                prop?.image_uri?.includes('https://')
                                  ? prop.image_uri
                                  : ENVIRONMENT.getBaseURL(props.selectedProductPlatform) + (prop?.image_uri || '')
                              }
                              alt="Prop"
                            />
                            <Button
                              onClick={() => {
                                setExistingProps(prev => prev.filter((_, i) => i !== idx));
                              }}
                              style={{
                                position: 'absolute',
                                top: '4px',
                                right: '4px',
                                width: '20px',
                                height: '20px',
                                minWidth: '20px',
                                padding: '0',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                backgroundColor: 'rgba(0,0,0,0.5)',
                                borderRadius: '4px',
                                border: 'none',
                              }}
                            >
                              <DeleteOutlined style={{ color: 'white', fontSize: '10px' }} />
                            </Button>
                          </div>
                        ))}
                      </>
                    }
                  </div>
                  <div className={`prompt-input-container`}>
                      <Input.TextArea disabled = {isLifestyleRequestLoading}
                      autoSize={{ minRows: 2, maxRows: 10 }}
                      value={lifestylePrompt}
                      onChange={(value) => setLifestylePrompt(value.target.value) } 
                        placeholder="Enter a prompt..." 
                        className="input-prompt-style-small" 
                      />
                    </div>
                    <div className="justify-space-between w-100">
                      <div className="justify-in-start">
                        <Button 
                            onClick={handlePropAddOption}
                            className="insp-img-upload-btn"
                        >
                          <PlusOutlined style={{ marginRight: '8px' }} /> 
                          <span className="manrope f-14 w-500">Add Prop</span>
                        </Button>
                        <Button ref={inspButtonRef2}
                            onClick={() => setInspImageDraggerOpened(true)}
                            className="insp-img-upload-btn ml-8"
                        >
                          <img src="/img/ai_creator/HeartAddOutlines.svg" style={{ marginRight: '8px' }} /> 
                          <span className="manrope f-14 w-500">{filesListRef.length == 0 && !selectedImageForInspectionLifestyle ? "Add inspiration" : "Replace inspiration"}</span>
                        </Button>
                      </div>

                    <Tooltip 
                      title={(isLifestyleRequestLoading ||
                        (lifestylePrompt.trim().length === 0 && filesListRef.length === 0 && !selectedImageForInspectionLifestyle) ||
                        filesListRef.some(file => file.status === "uploading")) ? "Please upload another inspiration image or change the prompt" : ""}
                    >
                      <span style={{ display: 'inline-block' }}>
                        <Button 
                          disabled={
                            isLifestyleRequestLoading ||
                            modelLoader ||
                            (lifestylePrompt.trim().length === 0 && filesListRef.length === 0 && !selectedImageForInspectionLifestyle) ||
                            filesListRef.some(file => file.status === "uploading")
                          }
                          className="generate-ai-btn font-14"
                          onClick={() => {
                            if(!selectedImageForLifestyle.length){
                              message.error('Please select product photo to use!')
                            }
                            else{
                              handleLifeStyleRequest()
                            }
                          }}
                        >
                          <img src="/img/ai_creator/ai-twinkle.svg" style={{ width: '20px', height: '20px', marginRight: '8px' }} /> 
                          <span>Generate</span>
                          {isLifestyleRequestLoading && <LoadingOutlined />}
                        </Button>
                      </span>
                    </Tooltip>
                  </div>

                </div>
              </div>
            </Col>

            {inspImageDraggerOpened &&
              
                <div ref={inspDraggerRef2} className="dragger-container">
                  <Dragger
                      accept=".jpg,.jpeg,.png,.tiff"
                      className="upload-height-170"
                      {...uploadPropsRef}
                      style={{
                        border: "1px dashed #595959",
                        background: "white",
                        borderRadius: 8,
                        padding: 16,
                        textAlign: "center",
                        position: "absolute",
                        top: 6,
                        left: 0,
                        right: 0
                      }}
                    >
                      <div className="manrope">  
                        <div style={{color: "black"}} >Drag & Drop or</div>
                        <div className="mt-10" style={{ display: 'flex', gap: 12, justifyContent: 'center', alignItems: 'center', flexWrap: 'wrap' }}>
                          <span style={{border: "1px solid #D9D9D9", display: 'inline-block', borderRadius: 4, padding: "8px 10px", color: "black"}}>
                            <UploadOutlined style={{marginRight: 4}} /> Upload photo
                          </span>
                          {hasInspirationLibrary && (
                            <Button
                              type="link"
                              className="manrope f-12 w-600"
                              style={{ padding: 0, height: 'auto' }}
                              onClick={(e) => {
                                e.preventDefault();
                                e.stopPropagation();
                                handleOpenInspirationLibrary();
                              }}
                            >
                              or Select from Library
                            </Button>
                          )}
                        </div>
                        <div className="mt-10" style={{ fontSize: 12, color: "#595959" }}>
                        Supported formats: JPG, PNG, WebP, HEIC, or TIFF
                        </div>
                      </div>
                    </Dragger>
                </div>
              
              }
          </Col>
         :
         <></>}
      </Row>

      {/* Inspiration library modal */}
      <Modal
        visible={inspirationLibraryModalOpen}
        onCancel={handleCancelInspirationLibraryModal}
        width={520}
        centered
        footer={null}
        style={{ top: 20 }}
      >
        <div style={{ padding: '0', marginTop: '16px' }}>
          <h4 className="manrope f-20 w-500 black-00" style={{ marginBottom: '24px' }}>
            Select Inspiration from Library
          </h4>

          {!hasInspirationLibrary ? (
            <Empty description="No inspirations available." />
          ) : (
            <div style={{ width: '100%' }}>
              <Input
                placeholder="Search inspirations..."
                value={inspirationLibrarySearchValue}
                onChange={(e) => setInspirationLibrarySearchValue(e.target.value)}
                className="manrope f-14 mat-search-bar"
                style={{ marginBottom: 12, height: 40 }}
              />

              <div style={{ width: '100%', maxHeight: 360, overflowY: 'auto' }}>
                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 12 }}>
                {(props.inspirationLibrary || [])
                  .filter((insp) => {
                    const q = (inspirationLibrarySearchValue || '').trim().toLowerCase();
                    if (!q) return true;
                    const idStr = (insp?.id != null ? String(insp.id) : '').toLowerCase();
                    const identifier = getInspirationIdentifier(insp).toLowerCase();
                    return idStr.includes(q) || identifier.includes(q);
                  })
                  .map((insp, idx) => {
                  const uri = getLibraryThumbUri(insp);
                  const selected = (selectedInspirationFromLibrary?.id != null && insp?.id != null)
                    ? String(selectedInspirationFromLibrary.id) === String(insp.id)
                    : selectedInspirationFromLibrary === insp;
                  return (
                    <div
                      key={insp?.id != null ? `insp-lib-${insp.id}` : `insp-lib-idx-${idx}`}
                      onClick={() => setSelectedInspirationFromLibrary(insp)}
                      style={{
                        width: '100%',
                        aspectRatio: '1 / 1',
                        border: selected ? '2px solid #276DD7' : '1px solid #D9D9D9',
                        borderRadius: 8,
                        overflow: 'hidden',
                        cursor: 'pointer',
                        backgroundColor: '#fff',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center'
                      }}
                    >
                      {uri ? (
                        <img
                          src={getDisplayImageSrc(uri, props.selectedProductPlatform)}
                          alt="Inspiration"
                          style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                        />
                      ) : (
                        <div className="manrope f-12" style={{ color: '#8C8C8C', padding: 8, textAlign: 'center' }}>
                          No preview
                        </div>
                      )}
                    </div>
                  );
                })}
              </div>
              </div>
            </div>
          )}

          <div className="justify-in-end" style={{ marginTop: 24 }}>
            <Button
              style={{ marginRight: 10 }}
              className="modal-okay-gray square font-14 create-product-modal-cancel"
              onClick={handleCancelInspirationLibraryModal}
            >
              Cancel
            </Button>
            <Button
              onClick={handleConfirmInspirationFromLibrary}
              className="modal-okay square font-14 create-product-modal-add"
              disabled={!selectedInspirationFromLibrary}
            >
              Add
            </Button>
          </div>
        </div>
      </Modal>

      <ActivityAndExploreSection
        displayableImages={props.displayableImages}
        aiImagesLoading={props.aiImagesLoading}
        showModal={props.showModal}
        activity_images={props.activity_images}
        regenerateJobLoader={regenerateJobLoader}
        yourActivityLoading={props.yourActivityLoading}
        regnerateLifestyleJob={regnerateLifestyleJob}
        activeTabKey={exploreSectionActiveTab}
        setActiveTabKey={setExploreSectionActiveTab}
        expandedJobId={props.expandedJobId}
        setExpandedJobId={props.setExpandedJobId}
        fetchYourActivityRendersData={props.fetchYourActivityRendersData}
        setYourActivityRenders={props.setYourActivityRenders}
        isLoadingMoreData={props.isLoadingMoreData}
        allDataLoaded={props.allDataLoaded}
        handleLoadMore={props.handleLoadMore}
      />
    </Content>

  )
}

const AiAssetCreate = (props) => {  
  const query = new URLSearchParams(props.location.search);
  const stage = query.get("stage") ?? 'options';
  const productId = query.get("productId") ?? "";
  const jobId = query.get("job_id") ?? "";
  const expandedJobIdParam = query.get("expanded_job_id") ?? "";
  const compressedState = query.get("state") ?? "";
  const decodeCompressedState = (encoded) => {
    if (!encoded) return null;
    try {
      // base64url -> base64
      let b64 = encoded.replace(/-/g, "+").replace(/_/g, "/");
      while (b64.length % 4) b64 += "=";
      const binary = atob(b64);
      const bytes = new Uint8Array(binary.length);
      for (let i = 0; i < binary.length; i++) bytes[i] = binary.charCodeAt(i);
      const jsonStr = pako.inflate(bytes, { to: "string" });
      return JSON.parse(jsonStr);
    } catch (e) {
      console.error("Failed to decode compressed state", e);
      return null;
    }
  };
  const decodedState = useMemo(() => decodeCompressedState(compressedState), [compressedState]);
  const queryParamImageUri = (query.get("img") ?? "") || (decodedState?.img ?? "");
  const [queryParamPrompt, setQueryParamPrompt] = useState(
    query.get("prompt") && query.get("prompt") !== "null"
      ? query.get("prompt")
      : (decodedState?.prompt ?? "")
    )
  const [queryParamInspectionImageUri, setQueryParamInspectionImageUri] = useState(
    query.get("imgInspection") && query.get("imgInspection") !== "null"
      ? query.get("imgInspection")
      : (decodedState?.imgInspection ?? "")
  )
  const [queryParamInspirationId, setQueryParamInspirationId] = useState(decodedState?.inspiration_id || null);
  const [queryParamProps, setQueryParamProps] = useState(decodedState?.props || []);
  const [aiModel, setAiModel] = useState(query.get("aiModel")?.toLocaleLowerCase() == 'true' ? true : false)
  const openProductModalParam = query.get("open_product_modal")?.toLowerCase() === 'true';
  
  // Remove open_product_modal parameter from URL after reading it
  useEffect(() => {
    console.log("query", query)
    if (query.has("open_product_modal")) {
      query.delete("open_product_modal");
      const newSearch = query.toString();
      const newUrl = `${window.location.pathname}${newSearch ? `?${newSearch}` : ''}`;
      window.history.replaceState({}, '', newUrl);
    }
  }, []); // Empty dependency array ensures this runs only once on mount
  
  const [assetGenerationStage, setAssetGenerationStage] = useState(stage);
  const [expandedJobId, setExpandedJobId] = useState(expandedJobIdParam);
  const [filesList, setFilesList] = useState([])
  const [isModalVisible, setisModalVisible] = useState(false);
  const [selectedImage, setSelectedImage] = useState({});
  const [imgIndex, setImgIndex] = useState(-1);
  const [deleteModal, setDeleteModal] = useState();
  const [deleteLoader, setDeleteLoader] = useState(false);
  const [libraryProductId, setLibraryProductId] = useState(productId);
  const [selectedProductPlatform, setSelectedProductPlatform] = useState('aws')
  const [imagesCount, setImagesCount] = useState({
    all: 0,
    silo: 0,
    lifestyle: 0,
    spin_360: 0,
    mp4: 0,
    favourites: 0,
    ai: 0,
  });
  const [imageType, setImageType] = useState("ai");
  const [yourActivityRenders, setYourActivityRenders] = useState([]);
  const [yourActivityLoading, setYourActivityLoading] = useState(true);
  const [requestStatus, setRequestStatus] = useState('update_subscription');
  const [imageRequestStatus, setImageRequestStatus] = useState('update_subscription');
  const [subscriptionUpgradeManagerModel, setSubscriptionUpgradeManagerModel] = useState(false)
  const [currentRequestType, setCurrentRequestType] = useState('ai_model')
  const [cardStatus, setCardStatus] = useState(0)
  const [requestStatusLoader, setRequestStatusLoader] = useState(true)
  const [openProductModal, setOpenProductModal] = useState(false)

  // Props/Inspiration libraries (used for "Select from Library" flows)
  const [propsLibrary, setPropsLibrary] = useState([]);
  const [inspirationLibrary, setInspirationLibrary] = useState([]);
  const [librariesLoading, setLibrariesLoading] = useState(false);
  
  // Pagination states
  const pageSize = 20;
  const [offset, setOffset] = useState(0);
  const [isLoadingMoreData, setIsLoadingMoreData] = useState(false);
  const [allDataLoaded, setAllDataLoaded] = useState(false);


  const fetchLibraries = useCallback(() => {
    try {
      const username = localStorage.getItem("username");
      const companyId = localStorage.getItem("company_id");
      if (!username || !companyId) return;

      setLibrariesLoading(true);
      const inspirationsPayload = {
        action: "get_all_inspirations",
        username,
        company_id: parseInt(companyId, 10)
      };
      const propsPayload = {
        action: "get_all_props",
        username,
        company_id: parseInt(companyId, 10)
      };

      Promise.all([
        axios.post(ENVIRONMENT.AI_ASSETS_HELPER, inspirationsPayload),
        axios.post(ENVIRONMENT.AI_ASSETS_HELPER, propsPayload),
      ])
        .then(([inspRes, propsRes]) => {
          const insp = inspRes?.data;
          const plib = propsRes?.data;
          setInspirationLibrary(Array.isArray(insp) ? insp : (insp?.data || insp?.items || []));
          setPropsLibrary(Array.isArray(plib) ? plib : (plib?.data || plib?.items || []));
        })
        .catch(() => {
          // Silent fail: UI will just not show library CTAs.
        })
        .finally(() => {
          setLibrariesLoading(false);
        });
    } catch (e) {
      // no-op
    }
  }, []);


  useEffect(() => {
    loadUserRequestStatus();
    fetchLibraries();

    // Update global variables with current localStorage values after component mounts
    CUSTOMER_USERNAME = localStorage.getItem("username");
    COMPANY_ID = localStorage.getItem('company_id');

    //Add Google Analytics Tags
    if (window.location.hostname !== "app.all3d.ai" && window.location.hostname !== "d1v6a0zmc8r81.cloudfront.net") return; // Load GTM only on production
    const script = document.createElement("script");
    
    script.innerHTML = `
    (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
    new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
    j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
    'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
    })(window,document,'script','dataLayer','GTM-PZWBHPCS');`;
    document.head.appendChild(script);
    
    const noscript = document.createElement("noscript");
    noscript.innerHTML = `<iframe src="https://www.googletagmanager.com/ns.html?id=GTM-PZWBHPCS"
    height="0" width="0" style="display:none;visibility:hidden"></iframe>`;
    document.body.appendChild(noscript);
    return () => {
      document.head.removeChild(script);
      document.body.removeChild(noscript);
    };
  }, []);


  // Get the inspiration image and prompt from the API if not provided in the query params
  useEffect(() => {
    if(productId && stage == 'lifestyle_generation' && (!queryParamInspectionImageUri || !queryParamPrompt)){
        axios.post(ENVIRONMENT.AI_ASSETS_HELPER, {
        "action": "get_ai_assets",
        "product_id": productId,
        "username": CUSTOMER_USERNAME,
        "company_id": COMPANY_ID || null
    }).then((res) => {
      if(res.data.inspiration_image_uri){
        setQueryParamInspectionImageUri(res.data.inspiration_image_uri)
        setQueryParamPrompt(res.data.prompt_text)
      }
    })
  }
}, [productId, stage])

  const loadUserRequestStatus = () => {
    // Check AI model request status
    let modelPayload = {
      "username": localStorage.getItem('username'),
      "request_type": "ai_model",
      "action": "check",
      "category": ""
    }
    axios.post(ENVIRONMENT.PAYMENT_GATEWAY, modelPayload)
        .then(res => {
            console.log('Model request status:', res.data)
            setRequestStatusLoader(false)
            setRequestStatus(res.data['request_allowed']);
            setCardStatus(res.data['card_status'])
            if(openProductModalParam){
              setOpenProductModal(true);
            }
        });

    // Check AI image request status
    let imagePayload = {
      "username": localStorage.getItem('username'),
      "request_type": "ai_image_1k",
      "action": "check",
      "category": ""
    }
    axios.post(ENVIRONMENT.PAYMENT_GATEWAY, imagePayload)
        .then(res => {
            console.log('Image request status:', res.data)
            setImageRequestStatus(res.data['request_allowed']);
        });
  }

  const calculateCount = (array) => {
    // Initialize counts for each category
    const counts = array.reduce(
      (counts, image) => {
        if (image.image_type === "silo") counts.silo++;
        if (image.image_type === "lifestyle") counts.lifestyle++;
        if (image.image_type === "spin_360") counts.spin_360++;
        if (image.image_type === "mp4") counts.mp4++;
        if (image.image_type === "ai") counts.ai++;
        if (image.isFavourite) counts.favourites++; // Count favourites if `isFavourite` is true
        counts.all++; // Increment total count

        return counts;
      },
      {
        all: 0,
        silo: 0,
        lifestyle: 0,
        spin_360: 0,
        mp4: 0,
        favourites: 0,
        ai: 0,
      }
    );

    // Set the state with the final counts
    setImagesCount(counts); // Assuming setImagesCount is already available in the scope
  };

  const handleOk = () => {
    setisModalVisible(false);
  };

  const handleCancel = () => {
    setisModalVisible(false);
  };

  const handleDeleteClick = (image, imgIndex) => {
    setDeleteModal(image);
    if (imgIndex) setImgIndex(imgIndex);
  };

  
  const aiGeneratedImagesPayload = useMemo(
    () => ({
      customer_username: CUSTOMER_USERNAME,
    }),
    [CUSTOMER_USERNAME]
  );
  const {
    data: aiGeneratedImages,
    refetch: aiImagesRefetech,
    isLoading: aiImagesLoading,
  } = useQuery(
    [`${ENVIRONMENT.AI_GENERATED_IMAGES}`, aiGeneratedImagesPayload],
    () => aiGeneratedRenders(aiGeneratedImagesPayload),
    {
      enabled: !!aiGeneratedImagesPayload,
      refetchOnMount: false,
      refetchOnWindowFocus: false,
    }
  );

  const aiGeneratedRenders = useCallback((payload) => {
    // return axios.post(ENVIRONMENT.AI_GENERATED_IMAGES, payload).then((res) => {
    //   return res.data.map((img) => {
    //     return {
    //       ...img,
    //       image_type: "ai",
    //       is360: img.threesixty_frames !== undefined,
    //       entity_id: img.product_id,
    //       platform: img.platform,
    //       entity_type: "product",
    //       image_name: img.id.toString() + ".jpg",
    //       threesixty_frames: img.threesixty_frames !== undefined ? img.threesixty_frames.data : null,
    //     };
    //   });
    // });
    return dummyAIgeneratedImages
    
  }, []);

  const updateOffset = (currentOffset) => {
    let newOffset = currentOffset + pageSize;
    setOffset(newOffset);
  };

  const fetchYourActivityRendersData = (callback = null, isInitialLoad = false, isPolling = false) => {
    // For polling, fetch all currently displayed items to check for status updates
    const currentItemsCount = yourActivityRenders.length || pageSize;
    
    const payload = {
        username: CUSTOMER_USERNAME,
        action: 'get_ai_assets_by_user',
        compress_response: true,
        limit: isPolling ? currentItemsCount : pageSize,
        offset: (isInitialLoad || isPolling) ? 0 : offset
    };
    
    // Only show loaders when NOT polling
    if (!isPolling) {
      if (isInitialLoad) {
        setYourActivityLoading(true);
        setOffset(0);
      } else {
        setIsLoadingMoreData(true);
      }
    }
    
    axios.post(ENVIRONMENT.AI_MODEL_HELPER, payload).then((res) => {
      let jsonData = {}
      if(res.data.isBase64Encoded){
        jsonData = Utilities.decompressData(res);
      } 
      else{
        jsonData = res.data;
      }
      console.log("jsonData", jsonData)
      
      // Check if we received less data than requested, meaning all data is loaded
      if (!jsonData || jsonData.length === 0) {
        if (!isPolling) {
          setAllDataLoaded(true);
          setIsLoadingMoreData(false);
          setYourActivityLoading(false);
        }
        return;
      }

      if (jsonData.length < pageSize && !isPolling) {
        setAllDataLoaded(true);
      }
      
      if (isInitialLoad || isPolling) {
        // Replace data for initial load or polling (silent refresh)
        setYourActivityRenders(jsonData);
        if (isInitialLoad) {
          updateOffset(0);
        }
      } else {
        // Append data for load more
        setYourActivityRenders(prevRenders => [...prevRenders, ...jsonData]);
        updateOffset(offset);
      }
      
      if (!isPolling) {
        setYourActivityLoading(false);
        setIsLoadingMoreData(false);
      }
      
      // Check if there are in-progress items and schedule next poll
      if (jsonData.some(item => (item.status === 'inprogress') || (item.latest_status === 'inprogress') || (item.status === 'completed' && item.renders.length === 0))) {
        setTimeout(() => {
          console.log("API needs to be called again")
          fetchYourActivityRendersData(null, false, true); // Poll silently without showing loader
        }, 10000); // 10 seconds delay
      }

      if (callback != null) {
        callback()
      }
    });
  };

  useEffect(() => {
    fetchYourActivityRendersData(null, true);
  }, [])

  const GetImageURL = (item, thumbnail = false, add_base_url = true) => {
    if (item.image_type == "silo") {
      if (
        item.image_status == "completed" &&
        (!("is_hidden" in item) || item.is_hidden !== true)
      ) {
        let silo_base_uri = "";
        let unique_attributer = "username";
        if (item.company_id) {
          silo_base_uri = "company/" + item.company_id;
          unique_attributer = "company";
        } else {
          silo_base_uri = item.username;
        }

        let imageUrl =
          ENVIRONMENT.getBaseURL(item["platform"]) +
          (thumbnail
            ? ENVIRONMENT.LOW_RES_QA_IMG_URI
            : ENVIRONMENT.QA_IMG_URI) +
          item["entity_id"] +
          "/" +
          silo_base_uri +
          "/" +
          item.camera_name +
          (thumbnail ? "_512" : "") +
          "." +
          item.image_format.replace("tiff", "jpg");
        return imageUrl;
      }
    }

    if (item.image_type === "ai") {
      if (item.is360) {
        let baseUrl = "";
        if (item.company_id) {
          baseUrl = "company/" + item.company_id;
        } else {
          baseUrl = item.captured_by ? item.captured_by : item.username;
        }

        let imageUrl =
          ENVIRONMENT.getBaseURL() +
          "product_assets/ai_generated_spin/" +
          `${item.product_id}/frames/` +
          item.uri;
        return imageUrl;
      }
      // Check if URI is already a full URL (like CloudFront URLs in dummy data)
      const isFullUrl = item.uri && (item.uri.startsWith('http://') || item.uri.startsWith('https://'));
      if(thumbnail){
        if (isFullUrl) {
          // For full URLs (dummy data), return as-is without _512 append
          return item.uri;
        }
        return add_base_url ? ENVIRONMENT.getBaseURL(item.platform) : '' + item.uri.replace(/(\.[^.]+)$/, "_512$1"); // add _512 before the file format to get low res url link
      }
      if (isFullUrl) {
        // For full URLs (dummy data), return as-is
        return item.uri;
      }
      return add_base_url ? ENVIRONMENT.getBaseURL(item.platform) : '' + item.uri;
    }

    if (item.image_type === "ai_generated_glb") {
      if (thumbnail) {
        return THUMBNAIL_URL + item.product_id + "_default.png" 

      }
      return ENVIRONMENT.getBaseURL(item.platform) + item.uri;
    }

    if (item.image_type == "lifestyle") {
      if (thumbnail) {
        const parts = item.filename.split(".");
        const updatedFilename =
          parts.slice(0, -1).join(".") + "_512." + parts.at(-1);
        return (
          ENVIRONMENT.getBaseURL(item.platform) +
          ENVIRONMENT.SCENE_THUMBNAIL_URI +
          item.entity_id +
          "/" +
          updatedFilename
        ).replace("tiff", "jpg");
      } else {
        return (
          ENVIRONMENT.getBaseURL(item.platform) +
          ENVIRONMENT.SCENE_THUMBNAIL_URI +
          item.entity_id +
          "/" +
          item.filename
        ).replace("tiff", "jpg");
      }
    }

    if (item.image_type == "spin_360") {
      let baseUrl = "";
      if (item.company_id) {
        baseUrl = "company/" + item.company_id;
      } else {
        baseUrl = item.captured_by ? item.captured_by : item.customer_username;
      }

      let imageUrl =
        ENVIRONMENT.getBaseURL() +
        "product_assets/threesixtys_frames/" +
        `${baseUrl}/` +
        item.spin_360_frames[0];
      return imageUrl;
    }

    if (item.image_type == "mp4") {
      let baseUrl = "";
      if (item.company_id) {
        baseUrl = "company/" + item.company_id;
      } else {
        baseUrl = item.captured_by ? item.captured_by : item.customer_username;
      }

      let imageUrl =
        ENVIRONMENT.getBaseURL() +
        "product_assets/video/" +
        `${baseUrl}/` +
        item.entity_id +
        ".mp4";
      return imageUrl;
    }
  };


  const displayableImages = useMemo(() => {
   
    const concatImg = [
    ]
    let imgs = [];
    if (aiGeneratedImages) {
      imgs = concatImg.concat(aiGeneratedImages).filter(img => img.status === "completed");
    }
    calculateCount(imgs)
    return imgs?.map((image, index) => ({
      ...image,
      orignalIndex: index,
      width: image.width,
      height: image.height,
      src: GetImageURL(image, false, true),
      thumbnail: GetImageURL(image, true, false),
      customOverlay: <AIGridOverlay obj={image} />,
    }))
    
  }, [aiGeneratedImages]);

  const showModal = useCallback((src) => {
    setSelectedImage(
      displayableImages.find((image) => image.src === src)
    );
    setisModalVisible(true);
    let index = displayableImages.findIndex((image) => image.src === src);
    setImgIndex(index);
  }, [displayableImages]); // Only re-create when `displayableImages` changes
  


  const renderDelete = (x) => {
    if (
      !x ||
      (!x.filename && !x.camera_name) ||
      x.image_type === "spin_360" ||
      x.image_type === "mp4"
    )
      return null;

    return (
      <Tooltip title={<span className="manrope f-12 white">Delete</span>}>
        <Button
          onClick={() => handleDeleteClick(x)}
          className="manrope f-14 w-500 lh-22 ai-action-btn ai-action-btn-red"
          icon={<DeleteOutlined />}
        />
      </Tooltip>
    );
  };

  const renderDownload = (src, obj) => {
    return null;

  };


  const renderGenerateHighResImage = (x) => {
    if (!x || !x.filename) return null;
  };


  const renderCollaborationTooltip = (image) => {
    if (
      image.image_type === "spin_360" ||
      image.image_type === "mp4" ||
      image.image_type === "ai"
    ) {
      return null;
    }
  };

  const renderReportButton = (x) => {
    return null
  };

  const renderFavouriteButton = (obj) => {
    if (obj.image_type === "ai") {
      return null;
    }
  }


  return (
    <>
      <CustomerMainLayout selected='26' remove_global_padding={true}>
          <AssetCreateOptions
            displayableImages={displayableImages}
            aiImagesLoading={aiImagesLoading} 
            stage={assetGenerationStage}
            setStage={setAssetGenerationStage}
            activity_images={yourActivityRenders}
            setYourActivityRenders={setYourActivityRenders}
            yourActivityLoading={yourActivityLoading}
            showModal={showModal}
            productId={libraryProductId}
            jobId={jobId}
            expandedJobId={expandedJobId}
            setExpandedJobId={(newExpandedJobId) => {
              const params = new URLSearchParams(window.location.search);
              if (newExpandedJobId) {
                params.set("expanded_job_id", newExpandedJobId);
              } else {
                params.delete("expanded_job_id");
              }
              const newUrl = `${window.location.pathname}${params.toString() ? `?${params.toString()}` : ""}`;
              window.history.replaceState({}, "", newUrl);
              setExpandedJobId(newExpandedJobId || "");
            }}
            setProductId={setLibraryProductId}
            aiModel={aiModel}
            setAiModel={setAiModel}
            fetchYourActivityRendersData={fetchYourActivityRendersData}
            selectedImgUri={queryParamImageUri}
            previousImgPrompt={queryParamPrompt}
            setSelectedProductPlatform={setSelectedProductPlatform}
            selectedProductPlatform={selectedProductPlatform}
            requestStatus={requestStatus}
            imageRequestStatus={imageRequestStatus}
            setCurrentRequestType={setCurrentRequestType}
            subscriptionUpgradeManagerModel={subscriptionUpgradeManagerModel}
            setSubscriptionUpgradeManagerModel={setSubscriptionUpgradeManagerModel}
            selectedImgInspectionUri={queryParamInspectionImageUri}
            initialInspirationId={queryParamInspirationId}
            initialProps={queryParamProps}
            inspirationLibrary={inspirationLibrary}
            propsLibrary={propsLibrary}
            requestStatusLoader={requestStatusLoader}
            isLoadingMoreData={isLoadingMoreData}
            allDataLoaded={allDataLoaded}
            openProductModal={openProductModal}
            handleLoadMore={() => {
              if (!isLoadingMoreData && !allDataLoaded) {
                fetchYourActivityRendersData();
              }
            }}
          />
          <TwoDImagesModal
            key={isModalVisible ? "open" : "closed"}
            isVisible={isModalVisible}
            handleOk={handleOk}
            handleCancel={handleCancel}
            currentfile={selectedImage}
            filteredImages={displayableImages}
            renderDelete={renderDelete}
            renderDownload={renderDownload}
            renderGenerateHighResImage={renderGenerateHighResImage}
            setType={setImageType}
            Type={imageType}
            imagesCount={imagesCount}
            renderCollaborationTooltip={renderCollaborationTooltip}
            renderReportButton={renderReportButton}
            renderFavouriteButton={renderFavouriteButton}
            aiPage={true}
          />

          <SubscriptionUpgradeManager
            subscriptionUpgradeManagerModel={subscriptionUpgradeManagerModel}
            setSubscriptionUpgradeManagerModel={setSubscriptionUpgradeManagerModel}
            cardStatus={cardStatus}
            loadUserRequestStatus={loadUserRequestStatus}
            requestType={currentRequestType}
          />

      </CustomerMainLayout>
    </>
  );
}

export default AiAssetCreate;
